@if (errors().length > 0) {
  <div class="flex font-bold mt-10">
    <confect-icon
      [icon]="_type === 'error' ? 'warning' : 'info'"
      iconClass="{{
        _type === 'warning' ? 'text-denim-500' : 'text-yellow-400'
      }} text-xl w-8 flex justify-end pr-2"
    >
      <div class="mr-1">{{ _issues.description }}</div>
    </confect-icon>
  </div>

  <div class="flex flex-col w-full h-full px-8">
    @for (error of errorsFiltered(); track error) {
      <div class="pt-5 flex items-center pb-2 space-x-1">
        <div class="font-bold">{{ error.count }}</div>
        <div>{{ _issues.display }}</div>
        <div class="px-2 py-1 rounded-md bg-slate-100 font-bold text-sm mx-1">
          {{ error.field }}
        </div>
      </div>
      <ngx-confect-table
        class="w-full h-full"
        [header]="error.header"
        [rows]="error.products"
      >
        <ng-template tableHeader let-cols="cols">
          @for (col of cols; track col; let i = $index) {
            <th
              scope="col"
              class="py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
              [ngClass]="{
                'pr-6': cols.length === i + 1,
                'px-6': cols.length !== i + 1,
              }"
              [style.width.%]="col.size * 100"
            >
              @if (cols.length === i + 1) {
                <confect-icon
                  [icon]="_type === 'error' ? 'warning' : 'info'"
                  iconClass="text-xl w-8 flex justify-end pr-2"
                  [ngClass]="{
                    'text-yellow-400': _type === 'error',
                    'text-denim-500': _type === 'warning',
                  }"
                >
                  {{ col.name }}
                </confect-icon>
              } @else {
                {{ col.name }}
              }
            </th>
          }
        </ng-template>

        <ng-template tableContent let-row="row" let-cols="cols">
          @for (col of cols; track col; let i = $index) {
            <td
              class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-700 text-ellipsis truncate"
              [ngClass]="{
                'bg-denim-500/50': cols.length === i + 1 && _type === 'warning',
                'bg-yellow-400/30': cols.length === i + 1 && _type === 'error',
                'px-8': cols.length === i + 1,
                'px-6': cols.length !== i + 1,
              }"
            >
              {{ row[col.name] ?? "-" }}
            </td>
          }
        </ng-template>
      </ngx-confect-table>
    }
  </div>
}
